export default "__VITE_ASSET__BOPTg9hj__"